if (Shopify.country === 'AU') {
  class FxGeoLocation extends HTMLElement {
    constructor() {
      super();
      // Initialize flags to determine visibility for Australian states/territories
      this.stateFlags = {
        'ACT': this.dataset.show_act === 'true',
        'NSW': this.dataset.show_nsw === 'true',
        'NT': this.dataset.show_nt === 'true',
        'QLD': this.dataset.show_qld === 'true',
        'SA': this.dataset.show_sa === 'true',
        'TAS': this.dataset.show_tas === 'true',
        'VIC': this.dataset.show_vic === 'true',
        'WA': this.dataset.show_wa === 'true',
      };
    }

    connectedCallback() {
      const raw = localStorage.getItem('GeoData');
      const geoData = raw ? JSON.parse(raw) : { country: '', region: '', time: 0 };
      if (geoData.region) {
        this.processGeoLocation(geoData.region);
      }

      window.addEventListener('GeoDataUpdated', (event) => {
        this.processGeoLocation(event.detail.region);
      });
    }

    processGeoLocation(data) {
      const shouldDisplay = this.stateFlags[data] || false;

      if (this.parentElement) {
        this.updateDisplay(shouldDisplay);
      } else {
        console.warn('parentElement is null, cannot apply classList manipulations.');
      }

      this.dispatchEvent(new CustomEvent('geoLocationProcessed', { bubbles: true, composed: true }));

      // Update announcement bar slider buttons visibility
      this.updateAnnouncementBarButtons();
    }

    updateAnnouncementBarButtons() {
      const slider = this.closest('.slider');
      if (!slider || !slider.id || !slider.id.startsWith('Slider-')) return;

      const sliderWrapper = slider.closest('.announcement-bar-slider');
      if (!sliderWrapper) return;

      const allGeoLocations = slider.querySelectorAll('.slider__slide fx-geo-location');
      let visibleCount = 0;

      allGeoLocations.forEach(function(geo) {
        const style = window.getComputedStyle(geo);
        if (style.display !== 'none') {
          visibleCount++;
        }
      });

      const prevBtn = sliderWrapper.querySelector('.slider-button--prev');
      const nextBtn = sliderWrapper.querySelector('.slider-button--next');

      if (visibleCount <= 1) {
        if (prevBtn) prevBtn.style.display = 'none';
        if (nextBtn) nextBtn.style.display = 'none';
      } else {
        if (prevBtn) prevBtn.style.display = '';
        if (nextBtn) nextBtn.style.display = '';
      }
    }

    updateDisplay(shouldDisplay) {
      const parentClasses = this.parentElement.classList;
      let activeClass;

      if (parentClasses.contains('slideshow')) {
        activeClass = 'activited-slide';
      } else if (parentClasses.contains('image--banner') || parentClasses.contains('banner-gallery-containner')) {
        activeClass = 'activited-image';

        if (!shouldDisplay && parentClasses.contains('image--banner')) {
          this.parentElement.parentElement.style.display = 'none';
        }
      }

      if (shouldDisplay) {
        this.style.display = 'contents';
        if (activeClass) this.classList.add(activeClass);
      } else {
        this.style.display = 'none';
        if (window.innerWidth <= 798) {
          this.parentElement.style.minHeight = '0';
        }
        if (activeClass) this.classList.remove(activeClass);
      }
    }
  }

  // Define the custom element 'fx-geo-location'
  customElements.define('fx-geo-location', FxGeoLocation);
}
